import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './components/app/app'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { RouterProvider } from './components/router-provider/router-provider'
import { Provider } from 'react-redux'
import store from './store/store'
import * as Sentry from '@sentry/react'
import { makeFetchTransport } from '@sentry/browser'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_HOST,
  // release: HOST_RELEASE,
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  enabled: import.meta.env.PROD,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // Добавляет frame.module_metadata из бандлов (host, shared, …) для маршрутизации событий.
    Sentry.moduleMetadataIntegration(),
  ],
  // Транспорт шлёт событие в каждый DSN из event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY] (см. beforeSend).
  transport: Sentry.makeMultiplexedTransport(makeFetchTransport),
  beforeSend(event, _hint) {
    const routes: Array<{ dsn: string; release?: string }> = []
    const seen = new Set<string>()
    const push = (dsn: string, release?: string) => {
      if (!dsn) return
      const key = dsn
      if (seen.has(key)) return
      seen.add(key)
      routes.push({ dsn }) //, release })
    }
    event.exception?.values?.forEach(ex => {
      ex.stacktrace?.frames?.forEach(frame => {
        const meta = frame.module_metadata as { dsn?: string; release?: string } | undefined
        if (meta?.dsn) push(meta.dsn) //, meta.release)
      })
    })
    if (routes.length > 0) {
      event.extra = { ...event.extra, [Sentry.MULTIPLEXED_TRANSPORT_EXTRA_KEY]: routes }
    }
    return event
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Упс, что-то пошло не так</div>}>
      <Provider store={store}>
        <BrowserRouter>
          <RouterProvider>
            <App
              globalOptions={{
                seller: '', // TODO: fix
              }}
            />
          </RouterProvider>
        </BrowserRouter>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
